import AppNavLink from './appNavLink'

export default AppNavLink
